import angular from 'angular';

import UserInterfaceSettingsComponent from './user-interface.cmpt';

export default angular
    .module('application.scene.authorized.scene.settings.scene.user-interface', [])
    .component(UserInterfaceSettingsComponent.selector, UserInterfaceSettingsComponent)
    .config(stateConfiguration);

/* @ngInject */
function stateConfiguration($stateProvider) {
    $stateProvider.state('authorized.calendar.settings.userInterface', {
        url: '/user-interface',
        component: UserInterfaceSettingsComponent.selector
    });
}



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/settings/scene/user-interface/index.js